import React from 'react';
import styled from 'styled-components';
import { ContributionDetailsProps } from './ContributionDetails';

type ContributionInvitationProps = ContributionDetailsProps

const StyledDiv = styled.div``;

const ContributionInvitation: React.FC<ContributionInvitationProps> = ({
  className,
}) => {
  return <StyledDiv className={className}>Contribution Invitation</StyledDiv>;
};

export default ContributionInvitation;
